var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Buy 1 Get X Free")]),_c('v-list-item-subtitle',[_vm._v("Free Quantity: "+_vm._s(_vm.promoItem.quantity))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }